import Button from "../../components/Button";
import SideBySideLayout from "../../components/SideBySideLayout";
import BGMobile from "./img/bg-mobile.jpg";
import BGDesktop from "./img/bg-desktop.jpg";
import "./style.scss";

export default function WelcomeView() {
  const dgUrl = `${
    import.meta.env.VITE_DG_URL
  }/customer/account/loginwithredirect?referer=${btoa(
    import.meta.env.VITE_DG_URL + "/inspiration_club"
  )}`;
  const vuseUrl = `${
    import.meta.env.VITE_VUSE_URL
  }/customer/account/loginwithredirect?referer=${btoa(
    import.meta.env.VITE_VUSE_URL + "/inspiration_club/"
  )}`;

  return (
    <SideBySideLayout
      position="top"
      bgImageDesktop={BGDesktop}
      bgImageMobile={BGMobile}
    >
      <div className="welcome-content">
        <div className="inner-content">
          <div className="copy">
            <h1>
              <strong>
                Werde Mitglied im <br />
                Inspiration Club!
              </strong>
            </h1>
            <p>
              Erhitzt du oder vapest du?
              <br />
              Sammle Punkte und löse Gutscheine für Angebote und Rabatte ein,
              die nur für
              <br />
              Mitglieder erhältlich sind.
            </p>
            <p>Jetzt den Inspiration Club entdecken und profitieren.</p>
            <p>
              <strong>
                Melde dich über deinen Shop an oder erstelle dort ein neues
                Konto, falls du
                <br />
                noch keines hast.
              </strong>
            </p>
          </div>

          <div className="buttons-wrapper">
            <p>Anmeldung durch:</p>
            <Button target="_self" btnClass="yellow" href={dgUrl}>
              myglo.com
            </Button>
            <Button target="_self" btnClass="yellow" href={vuseUrl}>
              vuse.com
            </Button>
          </div>
        </div>
      </div>
    </SideBySideLayout>
  );
}
